/*
 *
 * config for API
 *
 */

const BASE_URL = '/',

 API_ENDPOINTS = {
  AUTH: {
    FIND_USER: `${BASE_URL}api/v1/user/get`,
    CREATE_USER: `${BASE_URL}api/v1/user/create`,
    SEND_OTP: `${BASE_URL}api/v1/user/send_otp`,
    VERIFY_OTP: `${BASE_URL}api/v1/user/verify_otp`,
    SET_PASSWORD: `${BASE_URL}api/v1/user/password`,
    UPDATE_PASSWORD: `${BASE_URL}api/v1/user/update_password`,
    LOGIN: `${BASE_URL}api/v1/user/login`,
    LOGOUT: `${BASE_URL}api/v1/user/logout`,
    CURRENT_USER: `${BASE_URL}api/v1/user/current_user`,
    CLEVER_TAP_ID: typeof CLEVERTAP_ID === 'undefined' ? '' : CLEVERTAP_ID,
    HUB_SET_PASS: '/api/v1/users/passwords',
    HUB_UPDATE_PROFILE: '/api/v1/users/update',
    GET_USER_BY_MOBILE: '/api/v1/user/user_from_mobile'
  },
  ONBOARDING: {
    RESELLER: `${BASE_URL}api/v1/partners`,
    BUSINESS_ENTITIES: `${BASE_URL}api/v1/business_entities`,
    PINCODE: `${BASE_URL}api/v1/pincode_details`,
    VERIFY_PENNY: `${BASE_URL}api/v1/partners/verify_penny`,
    AGREEMENT_STATUS: `${BASE_URL}api/v1/partners/update_agreement_status`,
    UPLOAD_ICON: `${BASE_URL}api/v1/partners/upload_logo`,
    UPLOAD_COLOR: `${BASE_URL}api/v1/partners/submit_brand_details`,
    UPDATE_APPLICATION_DETAILS: `${BASE_URL}api/v1/partners/update_platform_credentials`,
  },
    IFSC_DETAILS: {
        IFSC: `${BASE_URL}api/v1/ifsc_details`,
        BANK_NAMES: `${BASE_URL}api/v1/ifsc_details/bank_names`,
        CITIES: `${BASE_URL}api/v1/ifsc_details/cities`,
        STATES: `${BASE_URL}api/v1/ifsc_details/states`,
        BRANCHES: `${BASE_URL}api/v1/ifsc_details/branches`
    },
    DOCUMENTS: {
        FETCH_DOCUMENT_CATEGORY_AND_TYPES: `${BASE_URL}api/v1/document_categories_and_types`,
        FETCH_DOCUMENTS:
            `${BASE_URL}api/v1/partners/kyc_documents`,
        UPLOAD_DOCUMENT:
            `${BASE_URL}api/v1/partners/kyc_documents`,
        UPLOAD_DOC_ATTACHMENT:
            `${BASE_URL}api/v1/partners/kyc_documents/append_attachment`,
        REMOVE_DOCUMENT: ({ docId }) => `${BASE_URL}api/v1/partners/kyc_documents/${docId}`,
        SUBMIT_DOCUMENTS:
            `${BASE_URL}api/v1/partners/submit_documents`,
        REMOVE_DOCUMENT_ATTACHMENT:
            `${BASE_URL}api/v1/partners/attachment`,
        MERGE_DOCUMENTS: ({ docId }) => `${BASE_URL}api/v1/partners/kyc_documents/${docId}/merge_documents`,
        GENERATE_SERVICE_AGREEMENT: ({ uuid }) => `${BASE_URL}api/v1/merchants/${uuid}/generate_agreement`
    },
   
  BULK_UPLOAD: {
    CREATE: `${BASE_URL}api/v1/partners/bulk_referrals`,
    SAMPLE_FILE: 'https://document-management-system-prod.s3.ap-south-1.amazonaws.com/partner-docs/static-content/Bulk_Referral_Sample_File.xlsx',
    UPDATE: ({ docId }) => `${BASE_URL}api/v1/partners/bulk_referrals/${docId}`,
    DELETE: ({ docId }) => `${BASE_URL}api/v1/partners/bulk_referrals/${docId}`
  },
  REFER: {
    BUSINESS_CATEGORIES: `${BASE_URL}api/v1/business_categories`,
    BUSINESS_SUB_CATEGORIES: `${BASE_URL}api/v1/business_sub_categories`
  },
  DASHBOARD: {
    MERCHANT_LIST: `${BASE_URL}api/v1/merchants`,
    DOWNLOAD_MERCHANT_LIST: `${BASE_URL}api/v1/merchants/download`,
    REFER_MERCHANT: `${BASE_URL}api/v1/partners/merchants`,
    SEND_SMS_LINK: (uuid) => `${BASE_URL}api/v1/merchants/${uuid}/send_sms_link`,
    INCENTIVES: `${BASE_URL}api/v1/reseller_incentives`,
    INVITE_USER: `${BASE_URL}api/v1/invites/create`,
    INVITEES: `${BASE_URL}api/v1/invites/show`,
    INVITE_UPDATE: `${BASE_URL}api/v1/invites/update`,
    CREATE_APP: `${BASE_URL}api/v1/partners/create_platform_credentials`,
    SHOW_APP_DETAILS: `${BASE_URL}api/v1/partners/show_platform_credentials`,
    CREATE_MERCHANT_STAFF: `${BASE_URL}api/v1/partners/add_partner_staff`,
    REDIRECT_ONBOARDING: `${BASE_URL}redirect`
  },
   AGREEMENT: {
      SEND_OTP: `${BASE_URL}api/v1/agreements/send_otp`,
      VERIFY_OTP: `${BASE_URL}api/v1/agreements/verify_otp`,
      DOWNLOAD: `${BASE_URL}api/v1/agreements/download_agreement`,
    },
  AWS:{
    APP_ICON_S3: "https://hub-accounts-test.s3.ap-south-1.amazonaws.com/hub-applications"
  }
};
export default API_ENDPOINTS;
